import { render, staticRenderFns } from "./UploadPlatesFile.vue?vue&type=template&id=058c76be&"
import script from "./UploadPlatesFile.vue?vue&type=script&lang=js&"
export * from "./UploadPlatesFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VFileInput,VRow})
